export default __webpack_public_path__ + "static/media/bg-box-search.9e09a8cb.svg";